export const initialState = {
  /* Default values here */
  isSignedIn: false,
  isLoading: true,
  theme: 'dark',
  pagesData: {},
  onMFATab: false,
  isModelMenuShowing: false,
  selectedModel: null,
  isVerboseMode: true,
  lastRequest: null,
  canceledRequests: [],
  fillablePDFCheckCounter: 0,
  isLightMode: process.env.REACT_APP_LIGHT_MODE === 'true' ? true: false,
}
